import { Button, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import AnimatedTick from '../../Icons/AnimatedTick/AnimatedTick';

const IntroEditScreen = ({profile, onCompleted}) => {

    //A simple tick animation and intro text
    const isMobile = useMediaQuery('(max-width: 768px)');
    const diameter = isMobile ? '90px' : '180px'; 
    const stage = 0; 

    const handleClick = ()=> {

        if(typeof onCompleted == 'function'){
            onCompleted(profile, stage); 
        }
    }

    return (
        <Box className='intro-edit-container'>

            <AnimatedTick diameter={diameter}/>

            <Typography className='edit-title' variant='h4'>
                New Account Successfully created!
            </Typography>

            <Button onClick={handleClick} variant='main'>
                <Typography className='edit-body' variant='h6'>
                    Let's finish setting it up
                </Typography>
            </Button>
            



        </Box>

    );
}

export default IntroEditScreen; 